import React, { Component } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import observacion from "../../images/proceso/OBSERVACION.png";
import exploracion from "../../images/proceso/EXPLORACION.png";
import analisis from "../../images/proceso/ANALISIS.png";
import orden from "../../images/proceso/ORDEN.png";
import excelencia from "../../images/proceso/EXCELENCIA.png";
import proyeccion from "../../images/proceso/PROYECCION.png";
import ejecucion from "../../images/proceso/EJECUCION.png";
import acompanamiento from "../../images/proceso/ACOMPAÑAMIENTO.png";

class Services2 extends Component {
  render() {
    var settings = {
      dots: true,
      arrows: true,
      speed: 3000,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2500,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    const service = [
      {
        image: observacion,
        title: "Observación",
        des: "La observación es clave, permitiendo analizar detalles, procesos y situaciones del entorno empresarial para identificar patrones, tendencias y oportunidades estratégicas.",
      },
      {
        image: exploracion, // Ruta de la imagen
        title: "Exploración",
        des: "Una investigación profunda del entorno empresarial, analizando tendencias, mejores prácticas e información clave para descubrir enfoques innovadores.",
      },
      {
        image: analisis, // Ruta de la imagen
        title: "Análisis",
        des: "Desglosamos la información recopilada, evaluando datos con herramientas analíticas para identificar fortalezas, debilidades y oportunidades, facilitando decisiones informadas.",
      },
      {
        image: orden,
        title: "Orden",
        des: "Esta fase organiza y estructura la información, estableciendo prioridades y un plan estratégico claro para alinear acciones con los objetivos y asegurar su implementación eficiente.",
      },
      {
        image: excelencia, // Ruta de la imagen
        title: "Excelencia",
        des: "La excelencia guía nuestras acciones, impulsándonos a superar expectativas y mantener altos estándares de calidad en cada solución y su implementación.",
      },
      {
        image: proyeccion, // Ruta de la imagen
        title: "Proyección",
        des: "Implica planificar a largo plazo, anticipando cambios y desarrollando estrategias que aseguren la sostenibilidad y adaptación a futuros desafíos.",
      },
      {
        image: ejecucion, // Ruta de la imagen
        title: "Ejecución",
        des: "Transformamos estrategias en acciones, asegurando una implementación eficiente y efectiva para alcanzar los objetivos y obtener resultados tangibles.",
      },
      {
        image: acompanamiento, // Ruta de la imagen
        title: "Acompañamiento",
        des: "Brindamos apoyo continuo tras la implementación efectiva de estrategias, asegurando un respaldo constante para adaptarse a cambios, contribuyendo así a su crecimiento sostenible.",
      },
    ];

    return (
      <section
        className={`wpo-service-section section-padding ${this.props.srvClass}`}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="wpo-section-title">
                <span>Nuestro Servicio</span>
                <h2>Descubre Nuestro proceso de servicio.</h2>
              </div>
            </div>
          </div>
          <div className="wpo-service-items wpo-service-slider owl-carousel">
            <Slider {...settings}>
              {service.map((service, sitem) => (
                <div className="col-lg-4 col-md-6 col-12" key={sitem}>
                  <div className="wpo-service-item">
                    <div className="wpo-service-icon">
                      <div className="icon">
                        <img
                          src={service.image}
                          className="m-3"
                          alt={service.title}
                        />
                      </div>
                    </div>
                    <div className="wpo-service-text">
                      <h2>{service.title}</h2>
                      <p>{service.des}</p>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    );
  }
}

export default Services2;
